export enum SITE_INTEGRATION_TYPE {
  CAFE24 = 1,
  SIXSHOP = 2,
  SHOPIFY = 3,
  NHN = 4,
  MAKESHOP = 5,
}
